import {
  CreateCartMutation,
  CreateCartMutationVariables,
  SetBuyerIdentityMutation,
  SetBuyerIdentityMutationVariables,
} from "./shopify-storefront.graphql";
import { ShopifyStorefrontClient } from "./storefront-client";

const createCartMutation = /* GraphQL */ `
  mutation CreateCart {
    cartCreate {
      cart {
        id
      }
    }
  }
`;

const setBuyerIdentityMutation = /* GraphQL */ `
  mutation SetBuyerIdentity(
    $cartId: ID!
    $buyerIdentity: CartBuyerIdentityInput!
  ) {
    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
      userErrors {
        field
        message
      }
    }
  }
`;

export async function createCart(
  client: ShopifyStorefrontClient,
  buyerIdentity: SetBuyerIdentityMutationVariables["buyerIdentity"],
): Promise<string> {
  const data = await client.request<
    CreateCartMutation,
    CreateCartMutationVariables
  >(createCartMutation, {});
  if (!data?.cartCreate?.cart) {
    throw new Error("Cart not created");
  }
  const cartID = data.cartCreate.cart.id;

  const buyerIdentityData = await client.request<
    SetBuyerIdentityMutation,
    SetBuyerIdentityMutationVariables
  >(setBuyerIdentityMutation, {
    cartId: cartID,
    buyerIdentity,
  });
  const errors = buyerIdentityData?.cartBuyerIdentityUpdate?.userErrors;
  if (errors && errors.length > 0) {
    console.error("Error setting buyer identity", errors);
  }
  return cartID;
}
